import { Outlet } from 'react-router-dom';
import { Sidebar } from '@/shared/components/layout';
import { Separator, SidebarInset, SidebarProvider, SidebarTrigger } from '@/shared/components/ui';
import type { RouteProp } from '@/shared/types/route-prop';

interface SidebarLayoutProps {
  routes: RouteProp[];
  mainClassName?: string;
}

export function SidebarLayout({ routes, mainClassName }: SidebarLayoutProps) {
  return (
    <SidebarProvider>
      <Sidebar routes={routes} />
      <SidebarInset className="flex flex-col">
        <header className="flex h-14 shrink-0 items-center gap-2 px-4 border-b border-border bg-card/80 backdrop-blur-sm md:hidden">
          <SidebarTrigger className="text-muted-foreground size-5" />
          <Separator orientation="vertical" className="h-4" />
          <span className="font-bold text-sm">GMN Portal</span>
        </header>
        <main className={mainClassName ?? 'flex-1 overflow-y-auto'}>
          <Outlet />
        </main>
      </SidebarInset>
    </SidebarProvider>
  );
}
